import React from 'react';
import { isGteSm } from '../../utils/viewport';
import T from '../components/T';

const CookieInfo = () => (
  <React.Fragment>
    <p>
      <T msg="cookieConsent.main.explanation" />
      <b><T msg="cookieConsent.main.plead" /></b>
    </p>
  </React.Fragment>
);

const MainPanel = ({ onShowSettings, infoExpanded, setInfoExpanded, setCookieContent }) => {
  const expandableInfo = !isGteSm();
  return (
    <div className="consent-panel">
      <p>
        <T msg="cookieConsent.main.shortInfo" />
      </p>
      {expandableInfo && !infoExpanded && (
        <p><button type="button" className="button-link" onClick={() => setInfoExpanded(true)}>
          <T msg="cookieConsent.common.moreInfo" />
           </button>
        </p>
      )}
      {(!expandableInfo || infoExpanded) && <CookieInfo />}
      {expandableInfo && infoExpanded && (
        <p><button type="button" className="button-link" onClick={() => setInfoExpanded(false)}>
          <T msg="cookieConsent.common.lessInfo" />
           </button>
        </p>
      )}

      {!infoExpanded && <React.Fragment>
        <div className="button-bar">
          <button
            type="button"
            className="c-button c-button--secondary"
            onClick={onShowSettings}>
            <T msg="cookieConsent.main.buttonSettings" />
          </button>
          <button
            type="button"
            className="c-button c-button--secondary"
            onClick={() => {
              setCookieContent('E');
            }}
          >
            <T msg="cookieConsent.main.buttonRejectAll" />
          </button>
          <button
            type="button"
            className="c-button c-button--primary"
            onClick={() => {
              setCookieContent('EMA');
            }}
          >
            <T msg="cookieConsent.main.buttonAcceptAll" />
          </button>
        </div>
                        </React.Fragment>}
    </div>
  );
};

export default MainPanel;



// WEBPACK FOOTER //
// ./app/Assets/js/features/cookieConsent/MainPanel.js